var App = App || {};

App.HomepageBanner = (function ($) {
    "use strict";

    function init() {

        const homepageBanners = $(".block.block-homepagebanner");

        homepageBanners.find(".block-background").ZagParallax({ divisor: 4 });

        if (homepageBanners.length) {
            homepageBanners.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(homepageBanner) {
        const carousel = homepageBanner.find(".splide");

        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: true,
                type: 'loop',
                fixedWidth: "980px",
                gap: "15px",
                drag: true,
                snap: false,
                perMove: 1,
                focus: 'center',
                trimSpace: false,
                breakpoints: {
                    991: {
                        fixedWidth: "245px",
                    },
                }
            });

            splideCarousel.mount();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.HomepageBanner.init();
});